/* Roadhouse merch pages (22.10.2026, templates/product.merch.json).
   - The gallery stage takes the colour of the chosen fabric (the swatch colour of the "Farbe" option).
   - "Vorne / Hinten" in the gallery: the front is the colour's own photo; the photos that belong to no colour are the
     backs, in the order of the colours. The print texts come from the description (snippets/rh-merch-stage).
   - Size advisor (snippets/rh-merch-fit): one size up or down when the description says it falls small or big; the
     recommended size can be chosen straight away.
   - Size chart toggle, and "Sag Bescheid" (snippets/rh-merch-notify) while the chosen variant is sold out.
   CSS in rh-skin.css, section 22. */
(function () {
  if (window.rhMerchReady) return;
  window.rhMerchReady = true;

  var data = {};
  try { data = JSON.parse(document.querySelector('[data-rh-merch]').textContent); } catch (e) {}
  // texts in the shop language from snippets/rh-merch-stage (locale keys rh.merch.js.*); German as fallback
  var T = {
    front: 'Vorne', back: 'Hinten', view: 'Ansicht', front_tag: 'Vorne:', back_tag: 'Hinten:',
    falls_small: 'fällt klein aus', falls_big: 'fällt groß aus',
    take_edge: 'Nimm <b></b> – kleiner bzw. größer gibt es nicht.', take: 'Nimm <b></b>, das Teil {why}.',
    pick: '{size} wählen', invalid: 'Bitte gib eine gültige E-Mail-Adresse ein.',
    thanks: 'Danke! Wir melden uns, sobald es wieder da ist.', failed: 'Das hat nicht geklappt. Schreib uns gern an info@road-house.at.'
  };
  if (data.t) for (var k in data.t) if (data.t[k]) T[k] = data.t[k];

  function gallery() { return document.querySelector('rh-gallery'); }
  function colourInput() {
    var inputs = document.querySelectorAll('variant-selects input[type="radio"]:checked');
    for (var i = 0; i < inputs.length; i++) {
      var n = (inputs[i].name || '').toLowerCase();
      if (n.indexOf('farbe') > -1 || n.indexOf('color') > -1 || n.indexOf('colour') > -1) return inputs[i];
    }
    return null;
  }

  // fabric colour on the stage
  function paintStage() {
    var stage = document.querySelector('.rh-gallery__stage');
    var input = colourInput();
    if (!stage || !input) return;
    var label = document.querySelector('label[for="' + input.id + '"]');
    var c = label ? getComputedStyle(label).getPropertyValue('--rh-sw').trim() : '';
    if (!c && label) { var sw = label.querySelector('.swatch'); if (sw) c = getComputedStyle(sw).backgroundColor; }
    if (c) { stage.style.setProperty('--rh-fabric', c); stage.classList.add('rh-mstage'); }
  }

  // front / back
  var sideBox = null;
  // fronts: the colours' own photos (or the first photo without colour photos); backs: the rest, same order
  function fronts() { return data.fronts && data.fronts.length ? data.fronts : (data.media || []).slice(0, 1); }
  function backs() { var f = fronts(); return (data.media || []).filter(function (id) { return f.indexOf(id) === -1; }); }
  function pair() {
    var g = gallery(); if (!g || !data.media) return null;
    var f = fronts(), b = backs(), cur = data.media[typeof g.index === 'number' ? g.index : 0];
    var k = f.indexOf(cur);
    if (k === -1) k = b.indexOf(cur);
    if (k === -1) {
      // a photo of neither kind: take the colour that is chosen in the variant picker
      var input = colourInput(); k = 0;
      if (input && data.colours) { var c = data.colours.indexOf(input.value); if (c > -1) k = c; }
    }
    if (!f[k] || !b[k]) return null;
    return { front: data.media.indexOf(f[k]), back: data.media.indexOf(b[k]), isBack: cur === b[k] };
  }
  function renderSides() {
    var g = gallery(); if (!g || !sideBox) return;
    var pr = pair(), back = pr && pr.isBack;
    sideBox.hidden = !pr;
    sideBox.querySelectorAll('[data-side]').forEach(function (b) { var on = (b.dataset.side === 'back') === back; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    var tag = sideBox.querySelector('[data-side-tag]');
    var text = back ? data.back : data.front;
    tag.textContent = text ? (back ? T.back_tag : T.front_tag) + ' ' + text : '';
    tag.hidden = !text;
  }
  function sides() {
    var stage = document.querySelector('.rh-gallery__stage');
    if (!stage || !data.media || data.media.length < 2) return;
    sideBox = document.createElement('div');
    sideBox.className = 'rh-mside';
    sideBox.innerHTML = '<div class="rh-mside__seg" role="group"><button type="button" data-side="front"></button><button type="button" data-side="back"></button></div><p class="rh-mside__tag" data-side-tag hidden></p>';
    sideBox.querySelector('[role="group"]').setAttribute('aria-label', T.view);
    sideBox.querySelector('[data-side="front"]').textContent = T.front;
    sideBox.querySelector('[data-side="back"]').textContent = T.back;
    stage.appendChild(sideBox);
    sideBox.querySelectorAll('[data-side]').forEach(function (b) {
      b.addEventListener('click', function () {
        var g = gallery(), pr = pair();
        if (!g || !pr) return;
        g.go(b.dataset.side === 'back' ? pr.back : pr.front);
        setTimeout(renderSides, 50);
      });
    });
    var track = stage.querySelector('[data-rg-track]');
    if (track) track.addEventListener('scroll', function () { clearTimeout(sides.t); sides.t = setTimeout(renderSides, 120); }, { passive: true });
    renderSides();
  }

  // size advisor
  function advisor() {
    document.querySelectorAll('[data-rh-advisor]').forEach(function (box) {
      var step = +box.dataset.step, sizes = box.dataset.sizes.split('|'), out = box.querySelector('[data-rh-advisor-out]');
      box.querySelectorAll('[data-size]').forEach(function (b) {
        b.addEventListener('click', function () {
          box.querySelectorAll('[data-size]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
          var i = sizes.indexOf(b.dataset.size), j = Math.max(0, Math.min(sizes.length - 1, i + step)), pick = sizes[j];
          var why = step > 0 ? T.falls_small : T.falls_big;
          out.innerHTML = '';
          var p = document.createElement('span');
          p.innerHTML = j === i ? T.take_edge : T.take.replace('{why}', why);
          p.querySelector('b').textContent = pick;
          out.appendChild(p);
          var input = [].find.call(document.querySelectorAll('variant-selects input[type="radio"]'), function (r) { var n = (r.name || '').toLowerCase(); return (n.indexOf('größe') > -1 || n.indexOf('groesse') > -1 || n.indexOf('size') > -1) && r.value === pick; });
          if (input && !input.checked) {
            var btn = document.createElement('button');
            btn.type = 'button'; btn.className = 'rh-mfit__take'; btn.textContent = T.pick.replace('{size}', pick);
            btn.addEventListener('click', function () { input.click(); btn.remove(); });
            out.appendChild(btn);
          }
        });
      });
    });
  }

  function chart() {
    document.querySelectorAll('[data-rh-chart-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = document.getElementById(b.getAttribute('aria-controls')); if (!c) return;
        c.hidden = !c.hidden; b.setAttribute('aria-expanded', !c.hidden);
      });
    });
  }

  // back in stock
  function notify() {
    var form = document.querySelector('[data-rh-notify]'); if (!form) return;
    var msg = form.querySelector('[data-rh-notify-msg]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.textContent = T.invalid; return; }
      form.classList.add('is-busy');
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(form.dataset.company), {
        method: 'POST',
        headers: { accept: 'application/json', revision: '2024-02-15', 'content-type': 'application/json' },
        body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + form.dataset.variant } } } } })
      }).then(function (r) {
        form.classList.remove('is-busy');
        if (r.ok || r.status === 202) { msg.textContent = T.thanks; form.email.value = ''; }
        else msg.textContent = T.failed;
      }).catch(function () { form.classList.remove('is-busy'); msg.textContent = T.failed; });
    });
  }
  function onVariant(v) {
    var form = document.querySelector('[data-rh-notify]');
    if (form && v) {
      form.dataset.variant = v.id;
      form.hidden = !!v.available;
      var name = form.querySelector('[data-rh-notify-name]'); if (name) name.textContent = v.title;
      var m = form.querySelector('[data-rh-notify-msg]'); if (m) m.textContent = '';
    }
    paintStage();
    setTimeout(renderSides, 400);
  }

  function start() {
    paintStage(); sides(); advisor(); chart(); notify();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) { onVariant(e && e.data && e.data.variant); });
    }
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) setTimeout(paintStage, 60); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
